import React from 'react';

function Spacer({settings}) {
  const {hidden = false} = settings || {};
  if (hidden) {
    return '';
  }
  return (
    <hr className="spacer" style={{
      width: '100%',
      border: 'none',
      height: '1px',
      backgroundColor: '#d7d7d7',
    }}/>
  )
}

export default Spacer;
